var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{attrs:{"color":_vm.badgeContext}},[_vm._v(_vm._s(_vm.badgeContent))])
}
var staticRenderFns = []

export { render, staticRenderFns }